import { Skeleton } from '@mui/material';
import { FC } from 'react';

interface UserGridSkeletonProps {
  width?: string;
  height?: string;
  sx?: object;
}

const UserGridSkeleton: FC<UserGridSkeletonProps> = ({
  width = '50%',
  height = '20%',
  sx,
}) => {
  return (
    <Skeleton
      variant="text"
      sx={{
        width: width,
        height: height,
        backgroundColor: 'var(--loader-color)',
        ...sx,
      }}
    />
  );
};

export default UserGridSkeleton;
